import {createLayerLegend, useLayerObject} from "base/map";
import {mapOverlayPanes} from "base/component/geo";
import {generatePopupHTML} from "app/common/PopupUtil";
import {formatUrl} from "app/common/TooltipUtil";

export const markerBaseOptions = {
    marker: "H",
    fillColor: "#dce3c1",
    radius: 10,
    color: "#ffc90e",
    addStroke: true,
    weight: 2,
    opacity: 1,
    fillOpacity: 1,
    pane: mapOverlayPanes[10],
    interactive: false,
};

export const discriminators = Object.freeze({
    SEA_USE_NAME: "seausename",
    SEA_USE_FUNCTION: "seausefct",
});

export const seaUseNameEntries = [
    {
        text: "Aquaculture",
        fn: val => val === "Aquaculture",
        fillColor: "#dce3c1",
    },
    {
        text: "Cables",
        fn: val => val === "Cables",
        fillColor: "#908cba",
    },
    {
        text: "Cultural heritage",
        fn: val => val === "Cultural heritage",
        fillColor: "#adc0e0",
    },
    {
        text: "Disposal areas",
        fn: val => val === "Disposal area",
        fillColor: "#ff8c33",
    },
    {
        text: "Fishing areas",
        fn: val => val === "Fishing areas",
        fillColor: "#a6d99a",
    },
    {
        text: "Maritime Traffic flows",
        fn: val => val === "Maritime Traffic flows",
        fillColor: "#fd5b78",
    },
    {text: "Military areas", fn: val => val === "Military areas", fillColor: "#fe94a7"},
    {
        text: "Nature Protection Conservation",
        fn: val => val === "Nature Protection Conservation",
        fillColor: "#aac48f",
    },
    {
        text: "Ocean Energy Facilities",
        fn: val => val === "Ocean Energy Facilities",
        fillColor: "#a1e3cc",
    },
    {
        text: "Oil and Gas",
        fn: val => val === "Oil and Gas",
        fillColor: "#ffe1ca",
    },
    {
        text: "Other/miscellaneous",
        fn: val => val === "Other/miscellaneous",
        fillColor: "#bae3e2",
    },
    {
        text: "Pipelines",
        fn: val => val === "Pipelines",
        fillColor: "#f8b3ff",
    },
    {
        text: "Ports",
        fn: val => val === "Ports",
        fillColor: "#b1e3c2",
    },
    {
        text: "Raw material extraction",
        fn: val => val === "Raw material extraction",
        fillColor: "#b9d1ff",
    },
    {
        text: "Scientific research",
        fn: val => val === "Scientific research",
        fillColor: "#ba9685",
    },
    {
        text: "Tourism and recreation",
        fn: val => val === "Tourism and recreation",
        fillColor: "#75a6ff",
    },
    {
        text: "Wind Farms",
        fn: val => val === "Wind Farms",
        fillColor: "#bebebe",
    },
].map(option => ({
    text: option.text,
    filterFn: option.fn,
    markerOptions: {...markerBaseOptions, fillColor: option.fillColor},
    opacityControl: markerBaseOptions.fillOpacity,
}));

export const seaUseFunctionEntries = [
    {
        text: "Allowed",
        fn: val => val === "Allowed",
        fillColor: "#908cba",
    },
    {
        text: "Forbidden",
        fn: val => val === "Forbidden",
        fillColor: "#adc0e0",
    },
    {
        text: "Potential",
        fn: val => val === "Potential",
        fillColor: "#ff8c33",
    },
    {
        text: "Priority",
        fn: val => val === "Priority",
        fillColor: "#a6d99a",
    },
    {
        text: "Reserved",
        fn: val => val === "Reserved",
        fillColor: "#fd5b78",
    },
    {
        text: "Restricted",
        fn: val => val === "Restricted",
        fillColor: "#b1e3c2",
    },
].map(option => ({
    text: option.text,
    filterFn: option.fn,
    markerOptions: {...markerBaseOptions, fillColor: option.fillColor},
    opacityControl: markerBaseOptions.fillOpacity,
}));

const zoningareasFieldConfig = [
    {key: "offsource", label: "Official Source", format: formatUrl},
    {key: "ms", label: "Member State"},
    {key: "hiluclu", label: "Hilucs Land Use", format: formatUrl},
    {key: "hilucsmsp", label: "Hilucs MSP", format: formatUrl},
    {key: "seausename", label: "Sea Use Name"},
    {key: "seausefct", label: "Sea Use Function"},
    {key: "seausedsc", label: "Sea Use Description"},
    {key: "originun", label: "Original Use Name"},
    {key: "originunen", label: "Original Use Name EN"},
];

// Separate function for tooltip content
const createZoningareasTooltip = data => {
    return generatePopupHTML("Zoning areas", data, zoningareasFieldConfig);
};

const LayerLegend = createLayerLegend({
    layerName: "Zoning areas",
    menuIconShape: markerBaseOptions.marker,
    discriminatorsAttributes: discriminators,
    discriminatorsLegends: [
        {
            field: discriminators.SEA_USE_NAME,
            text: "Sea Use Name",
            defaultIconOptions: markerBaseOptions,
            entries: seaUseNameEntries,
        },
        {
            field: discriminators.SEA_USE_FUNCTION,
            text: "Sea Use Function",
            defaultIconOptions: markerBaseOptions,
            entries: seaUseFunctionEntries,
        },
    ],
});

export function useZoningareasLayer(onSelectElement) {
    return useLayerObject({
        legend: LayerLegend,
        // metadata: "MARPLAN_Datos_Marisqueo_01122023_MD.XML",
        detail: false,
        getTooltip: ({feature}) => {
            let data = feature.properties;
            return createZoningareasTooltip(data);
        },
        // TODO next methods are necessary for map inside EntityListMap
        // We have to design this component without repeating if is from EntityListMap or MapProvider
        getCustomMarkerOptions: onSelectElement ? () => markerBaseOptions : null,
        defaultOnClick: ({feature}) => onSelectElement(feature.id),
    });
}
